// React
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
// コンポーネント
import ForgotPasswordInput from './ForgotPasswordInput';
import ForgotPasswordSuccess from './ForgotPasswordSuccess';

import sty from './ForgotPassword.module.css';

const ForgotPassword = () => {
    const [isSuccess, setIsSuccess] = useState(false);
    const location = useLocation();
    const role = location.state?.role;

    return (
        <div className="bg">
            <div className="account-container">
                {isSuccess ? (
                    <ForgotPasswordSuccess />
                ) : (
                    <ForgotPasswordInput setIsSuccess={setIsSuccess} role={role} />
                )}
            </div>
        </div>
    );
};

export default ForgotPassword;